import React from 'react'
import { ClientDiscountActions } from '../ClientDiscountActions'
import * as css from '../OrderManagementActions/OrderManagementActions.css'

interface IOrderManagementActionsProps {
  onRestore: (e: any) => void
  disabledRestore: boolean
}

export const DeletedOrderManagementActions: React.FunctionComponent<
  IOrderManagementActionsProps
> = ({ onRestore, disabledRestore }) => {
  return (
    <div className={css.orderActions}>
      <ClientDiscountActions
        onRestore={onRestore}
        disabled={disabledRestore || false}
        dontFreezeActionOnClick
      />
    </div>
  )
}
